var _rect, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599,
    y: 0.744,
    width: 32.627,
    height: 21.068,
    rx: 10.534,
    stroke: "#ECEFF3",
    strokeWidth: 0.958
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.154,
    cy: 11.278,
    rx: 1.436,
    ry: 1.439,
    transform: "rotate(-90 11.154 11.278)",
    fill: "#116DFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.912,
    cy: 11.278,
    rx: 1.436,
    ry: 1.439,
    transform: "rotate(-90 16.912 11.278)",
    fill: "#116DFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.669,
    cy: 11.278,
    rx: 1.436,
    ry: 1.439,
    transform: "rotate(-90 22.669 11.278)",
    fill: "#116DFF"
  })));
};
export default SvgDots;